import { decriptyBySecretKeyFunction } from "../../services/encripty-util.service";

export function getProductDescription(): string | null {
  let productDescription = decriptyBySecretKeyFunction(
    localStorage.getItem("bway-product-description")
  );

  if (productDescription === 'VIAGEM') {
    productDescription = 'DESPESAS';
  }

  if (productDescription === 'REFEICAO_BANDEIRADO') {
    productDescription = 'REFEIÇÃO';
  }

  if (productDescription === 'ALIMENTACAO_BANDEIRADO') {
    productDescription = 'ALIMENTAÇÃO';
  }

  if (productDescription === 'EMPRESARIAL_BANK') {
    productDescription = 'EMPRESARIAL';
  }

  if (productDescription === 'VALE_ESTAR_BEM') {
    productDescription = 'VALE ESTAR BEM';
  }

  if (productDescription === 'FLEXIVEL') {
    productDescription = 'FLEXÍVEL';
  }

  return productDescription;
}

export function getProductId(): number | null {
  const productId = localStorage.getItem('bway-product-id');
  if (productId) {
    return Number(decriptyBySecretKeyFunction(productId));
  }
  return null;
}
